import { SVGProps } from 'react';
const PauseFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
    {...props}>
    <path
      d="M15 5.91667V15.0833C15 15.3264 14.9042 15.5596 14.7337 15.7315C14.5632 15.9034 14.332 16 14.0909 16H11.8182C11.5771 16 11.3458 15.9034 11.1754 15.7315C11.0049 15.5596 10.9091 15.3264 10.9091 15.0833V5.91667C10.9091 5.67355 11.0049 5.44039 11.1754 5.26849C11.3458 5.09658 11.5771 5 11.8182 5H14.0909C14.332 5 14.5632 5.09658 14.7337 5.26849C14.9042 5.44039 15 5.67355 15 5.91667ZM8.18182 5H5.90909C5.66799 5 5.43675 5.09658 5.26627 5.26849C5.09578 5.44039 5 5.67355 5 5.91667V15.0833C5 15.3264 5.09578 15.5596 5.26627 15.7315C5.43675 15.9034 5.66799 16 5.90909 16H8.18182C8.42292 16 8.65415 15.9034 8.82464 15.7315C8.99513 15.5596 9.09091 15.3264 9.09091 15.0833V5.91667C9.09091 5.67355 8.99513 5.44039 8.82464 5.26849C8.65415 5.09658 8.42292 5 8.18182 5Z"
      fill="currentColor"
    />
  </svg>
);
export default PauseFilled;
